import React, { useEffect, useState, useRef } from "react"
import ReactMarkdown from "react-markdown"
import "./NotificationStack.css"

const NotificationStack = ({ notification, duration = 5000 }) => {
    const [stack, setStack] = useState([])
    const timersRef = useRef({})
    const lastRef = useRef(null)

    const enqueueNotification = ({ title, body }) => {
        const id = crypto.randomUUID()

        setStack(prev => [
            { id, body, title, closing: false },
            ...prev
        ])

        const closeTimer = setTimeout(() => {
            setStack(prev =>
                prev.map(n => (n.id === id ? { ...n, closing: true } : n))
            )
        }, duration - 350)

        const removeTimer = setTimeout(() => {
            setStack(prev => prev.filter(n => n.id !== id))
            delete timersRef.current[id]
        }, duration)

        timersRef.current[id] = { closeTimer, removeTimer }
    }

    useEffect(() => {
        if (!notification) return
        if (lastRef.current === notification) return
        lastRef.current = notification

        enqueueNotification(notification)
    }, [notification, duration])

    const manualRemove = (id) => {
        if (timersRef.current[id]) {
            clearTimeout(timersRef.current[id].closeTimer)
            clearTimeout(timersRef.current[id].removeTimer)
            delete timersRef.current[id]
        }

        setStack((prev) =>
            prev.map((n) => (n.id === id ? { ...n, closing: true } : n))
        )

        setTimeout(() => {
            setStack((prev) => prev.filter((n) => n.id !== id))
        }, 350)
    }

    return (
        <div className="bos-notification-stack">
            {stack.map((note) => (
                <div key={note.id} className={`bos-notification-box ${note.closing ? "closing" : ""}`}>
                    <div className="notification-icon">
                        <i className="fa fa-commenting-o" aria-hidden="true"></i>
                    </div>
                    <div className="notification-main">
                        <div className="notification-header">
                            <span className="title">{note.title || "Notification"}</span>
                        </div>
                        <div className="notification-body">
                            <ReactMarkdown>{note.body}</ReactMarkdown>
                        </div>
                    </div>
                    <div className="notification-actions">
                        <button type="button" onClick={() => manualRemove(note.id)} className="notification-close-button" aria-label="Dismiss notification">
                            <i className="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default NotificationStack
